webpackJsonp([110024142630367],{

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(19);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _SmartLink = __webpack_require__(36);
	
	var _SmartLink2 = _interopRequireDefault(_SmartLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LabCard = function (_Component) {
	  _inherits(LabCard, _Component);
	
	  function LabCard() {
	    _classCallCheck(this, LabCard);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.onMouseOver = function () {
	      _this.setState({ isHovered: true });
	    };
	
	    _this.onMouseOut = function () {
	      _this.setState({ isHovered: false });
	    };
	
	    _this.state = {
	      isHovered: false
	    };
	    return _this;
	  }
	
	  LabCard.prototype.render = function render() {
	    var _props = this.props,
	        description = _props.description,
	        name = _props.name,
	        url = _props.url,
	        asset = _props.asset,
	        category = _props.category;
	
	    var hoverTitleColor = this.state.isHovered ? 'slate' : 'black';
	    var opacityClass = (0, _classnames2.default)('transitionDuration-m', {
	      'opacity-80': this.state.isHovered,
	      'opacity-100': !this.state.isHovered
	    });
	    return _react2.default.createElement(
	      'div',
	      { onMouseOver: this.onMouseOver, onMouseOut: this.onMouseOut },
	      _react2.default.createElement(
	        _SmartLink2.default,
	        { url: url },
	        _react2.default.createElement(
	          _align2.default,
	          { type: 'center', typeM: 'left' },
	          _react2.default.createElement(
	            'div',
	            { className: opacityClass },
	            _react2.default.createElement(_Image2.default, asset)
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'padding', size: 'm', position: 'topBottom' },
	            _react2.default.createElement(
	              _spacing2.default,
	              { type: 'padding', size: 'xs', position: 'bottom' },
	              _react2.default.createElement(
	                _heading2.default,
	                { tag: 'div', size: 'm', weight: 'semibold', color: 'silver' },
	                category && category.name
	              )
	            ),
	            _react2.default.createElement(
	              _spacing2.default,
	              { type: 'padding', size: 'xs', position: 'bottom' },
	              _react2.default.createElement(
	                _heading2.default,
	                {
	                  tag: 'h3',
	                  weight: 'semibold',
	                  size: 'xxl',
	                  color: hoverTitleColor
	                },
	                name
	              )
	            ),
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'l' },
	              _react2.default.createElement(
	                'span',
	                { className: 'whiteSpace-normal truncateText-two' },
	                description
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return LabCard;
	}(_react.Component);
	
	exports.default = LabCard;
	
	
	LabCard.propTypes = {
	  description: _propTypes2.default.string.isRequired,
	  name: _propTypes2.default.string.isRequired,
	  url: _propTypes2.default.string.isRequired,
	  asset: _propTypes2.default.node.isRequired,
	  category: _propTypes2.default.node.isRequired
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-labs-card-js-9ec9b046a936d8a0f343.js